import React from "react";

function Cart() {
  return (
    <div>
      <h1 className="center">cart Page</h1>
    </div>
  );
}

export default Cart;
